export default __webpack_public_path__ + "static/media/15.2b89178f.png";